module.exports = __webpack_public_path__ + "img/logo.4e68b0b8.jpg";